var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4339,
    cy: 13.2148,
    r: 13.2152
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2188 12.9996C21.2188 17.4179 17.637 20.9996 13.2188 20.9996C8.80047 20.9996 5.21875 17.4179 5.21875 12.9996C5.21875 8.58136 8.80047 4.99963 13.2188 4.99963C17.637 4.99963 21.2188 8.58136 21.2188 12.9996ZM6.1875 12.9996C6.1875 16.8829 9.3355 20.0309 13.2188 20.0309C17.102 20.0309 20.25 16.8829 20.25 12.9996C20.25 9.11638 17.102 5.96839 13.2188 5.96839C9.3355 5.96839 6.1875 9.11638 6.1875 12.9996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6403 13.237C16.7739 13.1598 16.7739 12.967 16.6403 12.8899L11.7559 10.0698C11.6223 9.9927 11.4553 10.0891 11.4553 10.2434V15.8835C11.4553 16.0377 11.6223 16.1341 11.7559 16.057L16.6403 13.237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCircle);
export default __webpack_public_path__ + "static/media/video-circle.d7b149d6483f9110eb66498aaa8ff10f.svg";
export { ForwardRef as ReactComponent };